export default __webpack_public_path__ + "static/media/QUICK-UNI.d4ae676d.png";